import { PaymentMethod } from '../../common/common.types';

export class BankAccount {
	routingNumberLabel?: string;
	routingNumber?: string;
	accountNumber: string;
	reference: string;
	currencyCode: string;
}

export class NewEventPayment {
	isAuthorization: boolean;
	paymentMethod: PaymentMethod;
	token?: string;
	persistToken?: boolean;
	sourceId?: string;
	amount: number;
	takenOn?: Date;
	customerId?: number;
	notes?: string;
}

export class EventPaymentCapture {
	amount: number;
	notes?: string;
}

export class EventPaymentRefund {
	amount: number;
	notes?: string;
}
